interface BalanceDisplayData {
  raw: bigint;
  formatted: string;
  decimals: number;
}

interface SelectAcrossAvailableBalanceParams {
  sourceBalance: BalanceDisplayData | undefined;
  inkBalance: BalanceDisplayData | undefined;
  bridgeTxHash: string | undefined;
  canProceedToNado: boolean;
  preBridgeInkBalance?: bigint;
  expectedOutputAmount?: bigint;
}

export function selectAcrossAvailableBalance({
  sourceBalance,
  inkBalance,
  bridgeTxHash,
  canProceedToNado,
  preBridgeInkBalance,
  expectedOutputAmount,
}: SelectAcrossAvailableBalanceParams): BalanceDisplayData | undefined {
  if (bridgeTxHash && canProceedToNado && inkBalance) {
    if (preBridgeInkBalance !== undefined) {
      const delta =
        inkBalance.raw > preBridgeInkBalance
          ? inkBalance.raw - preBridgeInkBalance
          : BigInt("0");
      const raw =
        expectedOutputAmount !== undefined && expectedOutputAmount < delta
          ? expectedOutputAmount
          : delta;

      return {
        raw,
        formatted: formatRawBalance(raw, inkBalance.decimals),
        decimals: inkBalance.decimals,
      };
    }
    return inkBalance;
  }

  return sourceBalance;
}

function formatRawBalance(raw: bigint, decimals: number): string {
  const scale = BigInt(10) ** BigInt(decimals);
  const whole = raw / scale;
  const fraction = raw % scale;

  return `${whole.toString()}.${fraction.toString().padStart(decimals, '0')}`;
}
